(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["widgets/3color_h.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<table>\r\n<tr>\r\n    <td style=\"padding:5px 5px 5px 15px;\"><span style=\"background:#4ba34b;display:block;height:20px;width:20px;\"></span></td><td>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "legend.long_series"), env.opts.autoescape);
output += "</td>\r\n    <td style=\"padding:5px 5px 5px 15px;\"><span style=\"background:#336b9f;display:block;height:20px;width:20px;\"></span></td><td>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "legend.annual_series"), env.opts.autoescape);
output += "</td>\r\n    <td style=\"padding:5px 5px 5px 15px;\"><span style=\"background:#e59a39;display:block;height:20px;width:20px;\"></span></td><td>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "legend.infra_annual_series"), env.opts.autoescape);
output += "</td>\r\n</tr>\r\n</table>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
